export default {
  title: {
    id: 'bo_sellers-listing-search-product-results-title',
    defaultMessage: `{count, plural,
    =0 {0 result found for "{search}"}
    one {# result found for "{search}"}
    other {# results found for "{search}"}
  }`,
  },
}
